import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './../../js/UserContext';

const Require = ({ children, roles }) => {
    const { user, loading } = useContext(UserContext);
    if (loading) {
        return <p>Loading...</p>;
    }

    if (!roles || !roles.length)
        return children;

    if (!user || !roles || !user.roles || !user.roles.length)
        return <Navigate to="/profile" replace />;

    let authorized = false;
    roles.forEach(role => {
        if (authorized)
            return;
        if (user.roles.includes(role))
            authorized = true;
    });
    if (!authorized)
        return <Navigate to="/profile" replace />;
    return children;
};

export default Require;